// Matches both the RUM SDK's `  at <fn> @ <url>:<line>:<col>` frames and the
// raw V8 `    at <fn> (<url>:<line>:<col>)` frames an error boundary receives.
const EXTENSION_FRAME = /\b(?:chrome|moz|safari|safari-web)-extension:\/\//;

// Chrome and Edge extension ids are 32 letters from a to p.
const CHROMIUM_EXTENSION_ID = /\bchrome-extension:\/\/([a-p]{32})\//;

// A native builtin (`at getTime @ <anonymous>`, or raw `at Date.getTime (<anonymous>)`)
// says nothing about who called it, so the frame below it is the real top frame.
const NATIVE_FRAME = /(?:@ <anonymous>|\(<anonymous>\))$/;

export interface TopExtensionFrame {
  inExtension: boolean;
  /** Set only for a validated Chrome or Edge id, safe to put in a store URL. */
  chromiumExtensionId?: string;
}

export const getTopExtensionFrame = (stack: string): TopExtensionFrame => {
  const topFrame = stack
    .split('\n')
    .find((line) => /^\s+at\s/.test(line) && !NATIVE_FRAME.test(line.trimEnd()));
  if (topFrame === undefined || !EXTENSION_FRAME.test(topFrame)) {
    return { inExtension: false };
  }
  const chromiumExtensionId = CHROMIUM_EXTENSION_ID.exec(topFrame)?.[1];
  return chromiumExtensionId
    ? { inExtension: true, chromiumExtensionId }
    : { inExtension: true };
};

export const isChromiumExtensionId = (id: string): boolean => /^[a-p]{32}$/.test(id);

export const isTopFrameInExtension = (stack: string): boolean =>
  getTopExtensionFrame(stack).inExtension;
